import api from './client';

export interface ActivityLogEntry {
  id: number;
  action: string;
  entityType: string | null;
  entityId: number | null;
  description: string;
  ipAddress: string | null;
  createdAt: string;
  user: {
    id: number;
    name: string;
    email: string;
    avatar: string | null;
  };
}

export interface ActivityLogResponse {
  data: ActivityLogEntry[];
  total: number;
}

export interface UserActivityResponse extends ActivityLogResponse {
  user: {
    id: number;
    name: string;
    email: string;
    avatar: string | null;
  };
}

export interface ActivityLogParams {
  userId?: number | string;
  action?: string;
  from?: string;
  to?: string;
  limit?: number;
}

export const activityLogApi = {
  getActivityLog: (params?: ActivityLogParams): Promise<ActivityLogResponse> =>
    api.get('/admin/activity', { params }).then((r) => r.data),

  getUserActivity: (userId: number, params?: Omit<ActivityLogParams, 'userId'>): Promise<UserActivityResponse> =>
    api.get(`/admin/users/${userId}/activity`, { params }).then((r) => r.data),
};
